import api from './api';

export const feedbackService = {
    /**
     * File feedback as a GitHub issue through the server.
     *
     * Sent as multipart because of the optional screenshot; the shared client
     * defaults to JSON, so the content type is replaced and axios supplies the
     * boundary.
     *
     * @param {{ category: string, summary: string, details: string,
     *           page?: string, screenshot?: File | null }} feedback
     * @returns {Promise<{ message: string, issueNumber: number,
     *           screenshotStored: boolean | null }>}
     */
    async submitFeedback({ category, summary, details, page, screenshot }) {
        const form = new FormData();
        form.append('category', category);
        form.append('summary', summary);
        form.append('details', details);
        if (page) {
            form.append('page', page);
        }
        if (screenshot) {
            form.append('screenshot', screenshot);
        }
        const response = await api.post('/feedback', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    /**
     * Fetch a feedback screenshot for an administrator.
     *
     * The image needs the signed-in user's token, which a plain <img src>
     * cannot send, so it is fetched as a blob for the page to display.
     *
     * @param {string} id - The screenshot id from the issue's link.
     * @returns {Promise<Blob>}
     */
    async getScreenshot(id) {
        const response = await api.get(
            `/feedback/screenshots/${encodeURIComponent(id)}`,
            { responseType: 'blob' }
        );
        return response.data;
    },
};

export default feedbackService;
